import { Col, Row } from 'antd';
import SkeletonCustom from './SkeletonCustom';

const DigestSkeleton = function DigestSkeleton() {
  return (
    <Row gutter={16}>
      {[1, 2, 3, 4].map(() => (
        <Col span={15} xs={12} sm={12} md={6}>
          <SkeletonCustom
            width="100%"
            height="150px"
            margin="10px 5px"
            marginSm="10px 5px"
          />
        </Col>
      ))}
    </Row>
  );
};

export default DigestSkeleton;
